<mat-form-field [class.mat-form-field-invalid]="isMandatory">
    <mat-label *ngIf="placeholder" class="placeholder-text">{{placeholder}}</mat-label>
    <mat-select [formControl]="control" [id]="inputId" (ngModelChange)="deletePlaceholder()">
        <mat-option *ngFor="let option of options" [value]="option.value"
                    [title]="toolTip? option.viewValue: ''">
            {{(option.viewValue?.toString() || option.value?.toString() || '') | titlecase}}
        </mat-option>
    </mat-select>
    <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
    <mat-hint class="mat-error" *ngIf="isMandatory">
        {{listErrors.obligatoryField}}
    </mat-hint>
</mat-form-field>